import React from "react";
import { Outlet } from "react-router-dom";
import PortalHeadShell from "../components/PortalHeadShell";
import { getProductBySlug } from "../utils/portalProducts";
import EnterpriseControlSubnav from "./EnterpriseControlSubnav";
import { ENTERPRISE_CONTROL_BASE } from "./constants";

class EnterpriseControlErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div className="rounded-lg bg-red-50 text-red-800 px-4 py-3 text-sm space-y-2">
          <p className="font-semibold">Enterprise control could not render this page.</p>
          <pre className="text-xs whitespace-pre-wrap opacity-90">{String(this.state.error)}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}

const enterpriseProduct = getProductBySlug("enterprise");

export default function EnterpriseControlLayout() {
  return (
    <PortalHeadShell>
      <EnterpriseControlSubnav />
      <EnterpriseControlErrorBoundary>
        <Outlet
          context={{
            product: enterpriseProduct,
            enterpriseControlBase: ENTERPRISE_CONTROL_BASE,
          }}
        />
      </EnterpriseControlErrorBoundary>
    </PortalHeadShell>
  );
}
